export const ATTENDING_FORM = 'ATTENDING';
export const AUTH_FAILURE = 'auth failed';
export const CERTIFYING_FORM = 'CERTIFYING';
export const FORM_NARRATIVE = 'formNarrative';
export const FORM_NARRATIVE_CREATION_DATE = 'formNarrativeCreationDate';
export const FORM_NARRATIVE_ID = 'formNarrativeId';
export const FORM_PHYS = 'formPhys';
export const FORM_PHYS_VERBAL_DATE = 'formPhysVerbalDate';
export const FORM_PHYS_WRITTEN_DATE = 'formPhysWrittenDate';
export const FORM_TAKEN_BY_FIRST = 'formTakenByFirstName';
export const FORM_TAKEN_BY_LAST = 'formTakenByLastName';
export const FORM_VERBAL_TAKEN_BY_FIRST = 'formVerbalTakenByFirstName';
export const FORM_VERBAL_TAKEN_BY_LAST = 'formVerbalTakenByLastName';
export const FORM_VERBAL_TAKEN_BY_CREDENTIALS = 'formVerbalTakenByCredentials';
export const FORM_PASTING_OF_NARRATIVES = 'formpastingofnarratives';
export const FORM_ADDITIONAL_NARRATIVE = 'formadditionalnarrative';
export const GRID_COLUMN_KEY = 'listing-columns';
export const GRID_FILTER_KEY = 'listing-filter-model';
export const GRID_SORT_KEY = 'listing-sort-model';
export const APPROVAL_GRID_COLUMN_KEY = 'approval-listing-columns';
export const APPROVAL_GRID_FILTER_KEY = 'approval-listing-filter-model';
export const APPROVAL_GRID_SORT_KEY = 'approval-listing-sort-model';
// OP-31894: unsigned orders tab view mode (grouped by patient vs one row per order)
export const APPROVAL_GRID_VIEW_KEY = 'approval-listing-view';
export const APPROVAL_DETAIL_GRID_COLUMN_KEY =
  'approval-detail-listing-columns';
export const APPROVAL_DETAIL_GRID_FILTER_KEY =
  'approval-detail-listing-filter-model';
export const APPROVAL_DETAIL_GRID_SORT_KEY =
  'approval-detail-listing-sort-model';
export const APPROVAL_VIEW_GROUPED = 'grouped';
export const APPROVAL_VIEW_DETAIL = 'detail';
export const REVIEW_GRID_COLUMN_KEY = 'review-listing-columns';
export const REVIEW_GRID_FILTER_KEY = 'review-listing-filter-model';
export const REVIEW_GRID_SORT_KEY = 'review-listing-sort-model';
export const KEYCLOAK_TOKENS = 'keycloak-tokens';
export const NO_ATTENDING = -1;
export const RESTRICTED_ROLES = ['NP', 'PA'];
export const UNEXPECTED_TYPE = 'unexpected file type';
export const MD = 'MD';
export const WA = 'WA';
export const VA = 'VA';
export const LOC = 'LOC';
export const OTH = 'OTH';
export const DIS = 'DIS';
export const ADM = 'ADM';
export const REVIEW_OPEN = 'RO';
export const REVIEWED = 'RW';
export const CERTIFICATION = 'Certification';

export const ChangeOfLoc = 'Change in level of care';
export const Other = 'Other order';
export const PatientStandingOrder = 'Patient standing order';
export const Discharge = 'Discharge';
export const Admit = 'Admit order';
export const SignatureButton = 'SignatureButton';
export const VerbalButton = 'VerbalsButton';

export const VERBAL_BTN_TEXT_ID = 'verbal approval';
export const SIGNATURE_BTN_TEXT_ID = 'signature';

export const MILLISECONDS_IN_DAY = 86400000;
export const NUMBER_OF_DAYS_FOR_UNRECONCILED_MEDS = 16;

/* for CertContext reducer */
export const RESET_VALUES = 'RESET_VALUES';
export const SET_DOCTORS = 'SET_DOCTORS';
export const SET_CERT_DOCTORS = 'SET_CERT_DOCTORS';
export const SET_DOCTOR = 'SET_DOCTOR';
export const SET_REVIEW_TYPE = 'SET_REVIEW_TYPE';
export const FILTER_BY_USER = 'FILTER_BY_USER';
export const SET_FROM_DATE = 'SET_FROM_DATE';
export const SET_TO_DATE = 'SET_TO_DATE';
export const SET_DATE = 'SET_DATE';
export const SET_FORM_TYPE = 'SET_FORM_TYPE';
export const SET_PICKER_STATE = 'SET_PICKER_STATE';
export const SET_PIM = 'SET_PIM';
export const SET_CLEARSCRIPTS = 'SET_CLEARSCRIPTS';
export const SET_WORKFLOW = 'SET_WORKFLOW';
export const SET_OBSERVATION = 'SET_OBSERVATION';
export const SET_CERT_START_DATE = 'SET_CERT_START_DATE';
export const SET_VERBAL_DATE_LIMIT = 'SET_VERBAL_DATE_LIMIT';
export const SET_LATE_CERT = 'SET_LATE_CERT';
export const SET_CONFIRM_LATE_CERT = 'SET_CONFIRM_LATE_CERT';
export const SET_EMBEDDED = 'SET_EMBEDDED';
export const SET_DIMENSIONS = 'SET_DIMENSIONS';
export const SET_VERBAL_DATE = 'SET_VERBAL_DATE';
export const SET_BUTTON_CLICKED = 'SET_BUTTON_CLICKED';
export const SET_SMALL_WIDGET = 'SET_SMALL_WIDGET';

/* for ApprovalContext reducer */
export const SET_SELECTED_PATIENT = 'SET_SELECTED_PATIENT';
export const SET_SELECTED_DOCTOR = 'SET_SELECTED_DOCTOR';
export const SET_PPN = 'SET_PPN';
export const SET_PATIENT_REVIEWS_MAP = 'SET_PATIENT_REVIEWS_MAP';
export const SET_WORKFLOW_APPROVALS = 'SET_WORKFLOW_APPROVALS';
export const SET_RAW_REVIEWS = 'SET_RAW_REVIEWS';
export const SET_FORMATTED_REVIEWS = 'SET_FORMATTED_REVIEWS';
export const SET_UNRECONCILED_MEDS = 'SET_UNRECONCILED_MEDS';
export const SET_PATIENT_PSOS = 'SET_PATIENT_PSOS';
export const SET_COMPILED_APPROVALS = 'SET_COMPILED_APPROVALS';
export const SET_COMPILED_APPROVAL_DETAILS = 'SET_COMPILED_APPROVAL_DETAILS';
export const SET_PHYSICIAN_APPROVALS = 'SET_PHYSICIAN_APPROVALS';
export const SET_FILTER_BY_USER = 'SET_FILTER_BY_USER';

export const PPN = 'PPN';
export const PPNNO = 'PPNNO';
export const MFST = 'MFST';
export const VST = 'VST';

const createCertKeys = (
  formNarrative,
  formNarrativeCreationDate,
  formNarrativeId,
  formPhys,
  formPhysVerbalDate,
  formPhysWrittenDate,
  formTakenByFirstName,
  formTakenByLastName,
  formVerbalTakenByFirstName,
  formVerbalTakenByLastName,
  formVerbalTakenByCredentials,
  formpastingofnarratives,
  formadditionalnarrative,
  dmsPrefix,
  useFormPhys,
) => ({
  get [FORM_NARRATIVE]() {
    return formNarrative;
  },
  get [FORM_NARRATIVE_CREATION_DATE]() {
    return formNarrativeCreationDate;
  },
  get [FORM_NARRATIVE_ID]() {
    return formNarrativeId;
  },
  get [FORM_PHYS]() {
    return formPhys;
  },
  get [FORM_PHYS_VERBAL_DATE]() {
    return formPhysVerbalDate;
  },
  get [FORM_PHYS_WRITTEN_DATE]() {
    return formPhysWrittenDate;
  },
  get [FORM_TAKEN_BY_FIRST]() {
    return formTakenByFirstName;
  },
  get [FORM_TAKEN_BY_LAST]() {
    return formTakenByLastName;
  },
  get [FORM_VERBAL_TAKEN_BY_FIRST]() {
    return formVerbalTakenByFirstName;
  },
  get [FORM_VERBAL_TAKEN_BY_LAST]() {
    return formVerbalTakenByLastName;
  },
  get [FORM_VERBAL_TAKEN_BY_CREDENTIALS]() {
    return formVerbalTakenByCredentials;
  },
  get [FORM_PASTING_OF_NARRATIVES]() {
    return formpastingofnarratives;
  },
  get [FORM_ADDITIONAL_NARRATIVE]() {
    return formadditionalnarrative;
  },
  get dmsPrefix() {
    return dmsPrefix;
  },
  get useFormPhys() {
    return useFormPhys;
  },
});

export const ATTD_CERT_KEYS = [
  'attendingNarrative',
  'attendingNarrativeCreationDate',
  'attendingNarrativeId',
  'attendingPhys',
  'attendingPhysVerbalDate',
  'attendingPhysWrittenDate',
  'attendingTakenByFirstName',
  'attendingTakenByLastName',
  'attendingVerbalTakenByFirstName',
  'attendingVerbalTakenByLastName',
  'attendingVerbalTakenByCredentials',
  'allowpastingofnarratives',
  'additionalnarrativerequired',
];
export const HOSP_CERT_KEYS = [
  'hospiceNarrative',
  'hospiceNarrativeCreationDate',
  'hospiceNarrativeId',
  'hospicePhys',
  'hospicePhysVerbalDate',
  'hospicePhysWrittenDate',
  'hospiceTakenByFirstName',
  'hospiceTakenByLastName',
  'hospVerbalTakenByFirstName',
  'hospVerbalTakenByLastName',
  'hospVerbalTakenByCredentials',
  'allowpastingofnarratives',
  'additionalnarrativerequired',
];
export const ATTD_KEYS_MAPPED = createCertKeys(...ATTD_CERT_KEYS, 'attd', true);
export const CERT_KEYS_MAPPED = createCertKeys(
  ...HOSP_CERT_KEYS,
  'cert',
  false,
);

export const dateFormat = {
  format: 'longUTC',
};

/*
Taken from PSO Editor in progressnotes
 */

export const modules = {
  toolbar: [
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['clean'],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
};

export const formats = [
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
];

export const RTF_BLANK_STRING = '<p><br></p>';
